import React from 'react';
import Hero from './HeroArea';
import Category from './CategoryArea';
import Shop from './ShopArea';
import Discount from './DiscountArea';
import DiscountTwo from './DiscountTwoArea';
import Newsletter from './Newsletter';
import ShopTwo from './ShopTwoArea';
import Testimonial from './TestimonialArea';
import Service from './ServiceArea';
import Brand from './BrandArea';
import Blog from './BlogArea';

const HomeSixMain = () => {
  return (
    <main>
      <Hero />
      <Category />
      <Shop />
      <Newsletter />
      <Discount />
      <ShopTwo />
      <DiscountTwo />
      <Testimonial />
      <Service />
      <Brand />
      <Blog />
    </main>
  );
};

export default HomeSixMain;
